import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { SparepartStatus } from '../../../../../../constants.js'
import { getSparepartList } from '../../../../../../actions/spareparts'
import { hasSubscriptionPermission } from '../../../../../../utils/auth'
import { renderDateDiff, renderShortDate } from '../../../../../../utils/time'
import { translation } from '../../../../../../utils/helpers'
import { SparePartModuleIcons, ElementIcons, TimeLineIcons } from '../../../../../../shared/elements/icons'
import Divider from '../../../../../../shared/elements/divider'
import Expand from '../../../../../../shared/elements/expand'
import Icon from '../../../../../../shared/elements/icon'

/**
 * When called, the component will refetch the spareparts.
 * If @param orderId is null, all instances will update.
 * If @param orderId is a number, only the instances with a matchg orderId will update.
 */
export const UpdateSparePartPremiumList = (orderId = null) => {
  let event = new CustomEvent('Update-SparePartPremiumList', { detail: { orderId } })
  document.dispatchEvent(event)
}

class SparePartPremiumList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      OrderStep: 0,
      NotOrdered: [],
      NotUsedInStep: {
        Other: [],
        Ordered: [],
        Received: [],
        NotInUse: [],
        InStock: []
      },
      RemovedFromReport: {
        Other: [],
        Ordered: [],
        Received: [],
        NotInUse: [],
        InStock: []
      },
      Repair: {
        Other: [],
        Ordered: [],
        Received: [],
        NotInUse: [],
        InStock: []
      },
      Paint: {
        Other: [],
        Ordered: [],
        Received: [],
        NotInUse: [],
        InStock: []
      },
      Assembly: {
        Other: [],
        Ordered: [],
        Received: [],
        NotInUse: [],
        InStock: []
      }
    }

    this.getSparepartList = this.getSparepartList.bind(this)
    this.eventHandler = this.eventHandler.bind(this)
  }

  componentDidMount () {
    this.getSparepartList(this.props.orderId)
    document.addEventListener('Update-SparePartPremiumList', this.eventHandler)
  }

  componentWillUnmount () {
    document.removeEventListener('Update-SparePartPremiumList', this.eventHandler)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.orderId !== this.props.orderId) this.getSparepartList(this.props.orderId)
  }

  eventHandler ({ detail }) {
    let orderId = this.props.orderId
    if (detail.orderId === null || detail.orderId === orderId) this.getSparepartList(orderId)
  }

  getSparepartList (orderId) {
    this.props.getSparepartList(orderId).then(res => this.setState(res.data))
  }

  renderPart (part, key) {
    const sku = part.SparePartNumberAlias || part.OriginalSparePartNumber
    const description = part.Description
    const count = part.Count

    let warnings = []

    let icon = SparePartModuleIcons.OK
    let deliveryDateDiff = 0

    // Because supplier is an array. More dates are possible for a single sparepart item?
    let deliveryDates = []
    part.Suppliers.map((supplier) => {
      let deliveryDate = renderShortDate(supplier.DeliveryDate, true, true)
      deliveryDate ? deliveryDates.push(deliveryDate.toLowerCase()) : ''
      deliveryDateDiff = renderDateDiff(supplier.DeliveryDate, supplier.OldDeliveryDate)
    })

    // Get status and relevant info for given status
    switch (part.Status) {
      case SparepartStatus.NOTINUSE:
      case SparepartStatus.RECEIVED:
      case SparepartStatus.INSTOCK:
        icon = SparePartModuleIcons.OK
        break
      case SparepartStatus.ORDERED:
        if (deliveryDateDiff > 0) {
          icon = TimeLineIcons.Exclamation_Red
          let warningText = translation('18124') // Delayed
          warningText += ' ' + deliveryDates.toString()
          warnings.push(warningText)
        } else {
          icon = SparePartModuleIcons.Attention
        }
        break
      case SparepartStatus.UNKNOWN:
        icon = SparePartModuleIcons.Warning
        break
      case SparepartStatus.DEFECTIVE:
        warnings.push(translation('16453')) // Defective
        icon = TimeLineIcons.Exclamation_Red
        break
      case SparepartStatus.INCORRECT:
        warnings.push(translation('16454')) // Incorrect
        icon = TimeLineIcons.Exclamation_Red
        break
      case SparepartStatus.BACKORDER:
        icon = TimeLineIcons.Exclamation_Red
        let warningText = translation('18108') // Backorder

        if (deliveryDates.length > 0) {
          warningText += ' ' + deliveryDates.toString()
        } else {
          warningText += ' (' + translation('15392').toLowerCase() + ')'
        }

        warnings.push(warningText)
        break
    }

    // Unclear when to use Handled and what to use it for
    /* if (part.Handled === 0) {
      warnings.length = 0
      icon = SparePartModuleIcons.Warning
    } */

    // Show expected delivery date if the state and available information makes sence.
    const hiddenDateStates = [SparepartStatus.NOTINUSE, SparepartStatus.RECEIVED, SparepartStatus.INSTOCK]
    const sparepartDate = !hiddenDateStates.includes(part.Status) && deliveryDates.length > 0 ? deliveryDates[0] : ''

    // Render header for first item in list
    let sparepartHeader = (key !== 0) ? '' : (
      <div className='sparepartTitle'>
        <div className='sparePartName sparepartSubTitle'>{translation('14817')}</div>
        <div className='sparePartAmount sparepartSubTitle'>{translation('16441')}</div>
      </div>
    )

    // Render the list
    return (
      <div key={key}>
        {sparepartHeader}
        <div className='sparePartView sparePartItem'>
          <Icon size='s' icon={icon} />
          <div className='sparePartName'>
            <div>{sku} {sparepartDate}</div>
            <div>{description}</div>
          </div>
          <div className='sparePartItemAmount'>{count}</div>
        </div>
        {warnings.map((warning) => <div className='sparePartWarning'><Icon size='t' icon={ElementIcons.Indent} injectSvg /><div className=''>{warning}</div></div>)}
      </div>
    )
  }

  render () {
    // Only render for ProPremium
    const hasProPremium = hasSubscriptionPermission(this.props.auth, 30)
    if (!hasProPremium) {
      return null
    }

    let {
      OrderStep,
      RemovedFromReport,
      NotOrdered,
      Repair,
      Paint,
      Assembly,
      NotUsedInStep
    } = this.state

    const showRemovedFromReport = (
      Object.keys(RemovedFromReport.InStock).length > 0 ||
      Object.keys(RemovedFromReport.NotInUse).length > 0 ||
      Object.keys(RemovedFromReport.Ordered).length > 0 ||
      Object.keys(RemovedFromReport.Other).length > 0 ||
      Object.keys(RemovedFromReport.Received).length > 0
    )

    const showNotOrdered = Object.keys(NotOrdered).length > 0

    const showRepair = (
      Object.keys(Repair.InStock).length > 0 ||
      Object.keys(Repair.NotInUse).length > 0 ||
      Object.keys(Repair.Ordered).length > 0 ||
      Object.keys(Repair.Other).length > 0 ||
      Object.keys(Repair.Received).length > 0
    )

    const showPaint = (
      Object.keys(Paint.InStock).length > 0 ||
      Object.keys(Paint.NotInUse).length > 0 ||
      Object.keys(Paint.Ordered).length > 0 ||
      Object.keys(Paint.Other).length > 0 ||
      Object.keys(Paint.Received).length > 0
    )

    const showAssembly = (
      Object.keys(Assembly.InStock).length > 0 ||
      Object.keys(Assembly.NotInUse).length > 0 ||
      Object.keys(Assembly.Ordered).length > 0 ||
      Object.keys(Assembly.Other).length > 0 ||
      Object.keys(Assembly.Received).length > 0
    )

    const showNotUsedInStep = (
      Object.keys(NotUsedInStep.InStock).length > 0 ||
      Object.keys(NotUsedInStep.NotInUse).length > 0 ||
      Object.keys(NotUsedInStep.Ordered).length > 0 ||
      Object.keys(NotUsedInStep.Other).length > 0 ||
      Object.keys(NotUsedInStep.Received).length > 0
    )

    let isAfterRepair = ![0, 1, 101, 102].includes(OrderStep)
    let isAfterPaint = [103, 104, 7, 8].includes(OrderStep)
    let isAfterAssembly = [104, 7, 8].includes(OrderStep)

    const repairOpen = !(Object.keys(Repair.Other).length === 0 && Object.keys(Repair.Ordered).length === 0 && isAfterRepair)
    const paintOpen = !(Object.keys(Paint.Other).length === 0 && Object.keys(Paint.Ordered).length === 0 && isAfterPaint)
    const assemblyOpen = !(Object.keys(Assembly.Other).length === 0 && Object.keys(Assembly.Ordered).length === 0 && isAfterAssembly)
    const notUsedInStepOpen = Object.keys(NotUsedInStep.Other).length > 0

    return (
      <div className='premiumList'>
        {showRemovedFromReport && <span>
          <Expand title={translation('16499')} defaultOpen>
            <div className='nested'>
              {Object.keys(RemovedFromReport.Other).length > 0 &&
                <div>
                  {RemovedFromReport.Other.map(this.renderPart)}
                </div>
              }
              {Object.keys(RemovedFromReport.NotInUse).length > 0 &&
                <Expand title={translation('16449')} >
                  <div>
                    {RemovedFromReport.NotInUse.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(RemovedFromReport.Ordered).length > 0 &&
                <Expand title={translation('14797')} >
                  <div>
                    {RemovedFromReport.Ordered.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(RemovedFromReport.Received).length > 0 &&
                <Expand title={translation('16452')} >
                  <div>
                    {RemovedFromReport.Received.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(RemovedFromReport.InStock).length > 0 &&
                <Expand title={translation('14799')} >
                  <div>
                    {RemovedFromReport.InStock.map(this.renderPart)}
                  </div>
                </Expand>
              }
            </div>
          </Expand>
          <Divider /></span>
        }
        {showNotOrdered && <span>
          <Expand title={translation('14796')} defaultOpen>
            <div>
              {NotOrdered.map(this.renderPart)}
            </div>
          </Expand>
          <Divider /></span>
        }
        {showRepair && <span>
          <Expand title={translation('18122')/* Spare parts for repair */} defaultOpen={repairOpen}>
            <div className='nested'>
              {Object.keys(Repair.Other).length > 0 &&
              <div>
                {Repair.Other.map(this.renderPart)}
              </div>
              }
              {Object.keys(Repair.NotInUse).length > 0 &&
                <Expand title={translation('16449')} defaultOpen={repairOpen}>
                  <div>
                    {Repair.NotInUse.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Repair.Ordered).length > 0 &&
                <Expand title={translation('14797')} defaultOpen={repairOpen}>
                  <div>
                    {Repair.Ordered.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Repair.Received).length > 0 &&
                <Expand title={translation('16452')} defaultOpen={repairOpen}>
                  <div>
                    {Repair.Received.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Repair.InStock).length > 0 &&
                <Expand title={translation('14799')} defaultOpen={repairOpen}>
                  <div>
                    {Repair.InStock.map(this.renderPart)}
                  </div>
                </Expand>
              }
            </div>
          </Expand>
          <Divider /></span>
        }
        {showPaint && <span>
          <Expand title={translation('14818')} defaultOpen={paintOpen}>
            <div className='nested'>
              {Object.keys(Paint.Other).length > 0 &&
              <div>
                {Paint.Other.map(this.renderPart)}
              </div>
              }
              {Object.keys(Paint.NotInUse).length > 0 &&
                <Expand title={translation('16449')} defaultOpen={paintOpen}>
                  <div>
                    {Paint.NotInUse.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Paint.Ordered).length > 0 &&
                <Expand title={translation('14797')} defaultOpen={paintOpen}>
                  <div>
                    {Paint.Ordered.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Paint.Received).length > 0 &&
                <Expand title={translation('16452')} defaultOpen={paintOpen}>
                  <div>
                    {Paint.Received.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Paint.InStock).length > 0 &&
                <Expand title={translation('14799')} defaultOpen={paintOpen}>
                  <div>
                    {Paint.InStock.map(this.renderPart)}
                  </div>
                </Expand>
              }
            </div>
          </Expand>
          <Divider /></span>
        }
        {showAssembly && <span>
          <Expand title={translation('14816')} defaultOpen={assemblyOpen}>
            <div className='nested'>
              {Object.keys(Assembly.Other).length > 0 &&
              <div>
                {Assembly.Other.map(this.renderPart)}
              </div>
              }
              {Object.keys(Assembly.NotInUse).length > 0 &&
                <Expand title={translation('16449')} defaultOpen={assemblyOpen}>
                  <div>
                    {Assembly.NotInUse.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Assembly.Ordered).length > 0 &&
                <Expand title={translation('14797')} defaultOpen={assemblyOpen}>
                  <div>
                    {Assembly.Ordered.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Assembly.Received).length > 0 &&
                <Expand title={translation('16452')} defaultOpen={assemblyOpen}>
                  <div>
                    {Assembly.Received.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(Assembly.InStock).length > 0 &&
                <Expand title={translation('14799')} defaultOpen={assemblyOpen}>
                  <div>
                    {Assembly.InStock.map(this.renderPart)}
                  </div>
                </Expand>
              }
            </div>
          </Expand>
          <Divider /></span>
        }
        {showNotUsedInStep && <span>
          <Expand title={translation('18123')} defaultOpen={notUsedInStepOpen}>
            <div className='nested'>
              {Object.keys(NotUsedInStep.Other).length > 0 &&
              <div>
                {NotUsedInStep.Other.map(this.renderPart)}
              </div>
              }
              {Object.keys(NotUsedInStep.NotInUse).length > 0 &&
                <Expand title={translation('16449')} defaultOpen={notUsedInStepOpen}>
                  <div>
                    {NotUsedInStep.NotInUse.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(NotUsedInStep.Ordered).length > 0 &&
                <Expand title={translation('14797')} defaultOpen={notUsedInStepOpen}>
                  <div>
                    {NotUsedInStep.Ordered.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(NotUsedInStep.Received).length > 0 &&
                <Expand title={translation('16452')} defaultOpen={notUsedInStepOpen}>
                  <div>
                    {NotUsedInStep.Received.map(this.renderPart)}
                  </div>
                </Expand>
              }
              {Object.keys(NotUsedInStep.InStock).length > 0 &&
                <Expand title={translation('14799')} defaultOpen={notUsedInStepOpen}>
                  <div>
                    {NotUsedInStep.InStock.map(this.renderPart)}
                  </div>
                </Expand>
              }
            </div>
          </Expand>
          <Divider /></span>
        }
      </div>
    )
  }
}

SparePartPremiumList.propTypes = {
  orderId: PropTypes.number.isRequired,
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getSparepartList
})(SparePartPremiumList)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/SpareParts/PremiumList/index.js